import { IconID, IconSize } from '../../icon';
export const selectedPaginationDotIconID = IconID.CIRCLE;
export const paginationDotIconID = IconID.EMPTY_CIRCLE;
export const hoverPaginationDotIconID = IconID.EMPTY_CIRCLE_HOVER;
export const TOTAL_PAGINATION_DOTS = 5;
export const FULLDOTS_SUBSET = 3;
/**
 * The getFullPaginationDot method is employed to retrieve the dot with its full size.
 */
export const getFullPaginationDot = (key, selected, pageIndex) => {
    return {
        key,
        size: IconSize.XSMALL,
        icon: selected ? selectedPaginationDotIconID : paginationDotIconID,
        pageIndex,
    };
};
/**
 * The getFullPaginationDot method is employed to retrieve the dot with its medium size.
 */
export const getMediumPaginationDot = (key, pageIndex) => {
    return {
        key,
        size: IconSize.XXSMALL,
        icon: paginationDotIconID,
        pageIndex,
    };
};
/**
 * The getFullPaginationDot method is employed to retrieve the dot with its small size.
 */
export const getSmallPaginationDot = (key, pageIndex) => {
    return {
        key,
        size: IconSize.XXXSMALL,
        icon: paginationDotIconID,
        pageIndex,
    };
};
/**
 * The constant NO_OF_PAGINATION_DOTS is utilized in pagination optimized dots to determine the number of pages to fetch.
 */
export const NO_OF_PAGINATIOIN_DOTS = 5;
/**
 * The constant FETCH_NEXT_PAGES_WHEN_REMAINING_PAGES_ARE is employed in pagination optimized dots to fetch
 * the next set of pages when there are only three pages remaining.
 *
 * Example:
 * Pages 6 (5 + 1 (isLastBatch)) and currentPage is 3, then when we click on next button,
 * we need to know whethere 7the page is there or not. so it required to fetch the next set of pages.
 */
export const FETCH_NEXT_PAGES_WHEN_REMAINING_PAGES_ARE = 3;
/**
 * The getPaginationOptimizedDotsProps method is used to get the prepared pagination optimized dots object.
 */
export const getPaginationOptimizedDotsProps = (offset, batchSize, previous, next, jumpTo, fetchOffset, objectsCount, isLastBatch, fetchPrevious, fetchNext) => ({
    offset,
    batchSize,
    previous,
    next,
    jumpTo,
    fetch: {
        offset: fetchOffset,
        batchSize: batchSize * NO_OF_PAGINATIOIN_DOTS,
        objectsCount,
        isLastBatch,
        previous: fetchPrevious,
        next: fetchNext,
    },
});
/**
 * The getPaginationDots method is used to prepare the state of the current pagination.
 *
 * @param pages the number of pages
 * @param currentPage the current selected page, which start from 1.
 * @returns the entire state of pagination dots.
 */
export const getPaginationDots = (pages, currentPage) => {
    // Total pages is less than 5
    if (pages <= TOTAL_PAGINATION_DOTS) {
        const dots = [];
        for (let i = 0; i < pages; i++) {
            dots.push(getFullPaginationDot(i.toString(), currentPage === i + 1, i));
        }
        return {
            disablePrevious: currentPage === 1,
            disableNext: currentPage === pages,
            dots,
        };
    }
    // pagination dots state for first 3 page
    if (currentPage <= FULLDOTS_SUBSET) {
        return {
            disablePrevious: currentPage === 1,
            disableNext: false,
            dots: [
                getFullPaginationDot('1', currentPage === 1, 0),
                getFullPaginationDot('2', currentPage === 2, 1),
                getFullPaginationDot('3', currentPage === 3, 2),
                getMediumPaginationDot('4', 3),
                getSmallPaginationDot('5', 4),
            ],
        };
    }
    // pagination dots state for last 3 page
    if (currentPage >= pages - 2) {
        return {
            disablePrevious: false,
            disableNext: currentPage === pages,
            dots: [
                getSmallPaginationDot('1', pages - 5),
                getMediumPaginationDot('2', pages - 4),
                getFullPaginationDot('3', currentPage === pages - 2, pages - 3),
                getFullPaginationDot('4', currentPage === pages - 1, pages - 2),
                getFullPaginationDot('5', currentPage === pages - 0, pages - 1),
            ],
        };
    }
    // Intermediate pagination dots state
    return {
        disablePrevious: false,
        disableNext: false,
        dots: [
            getMediumPaginationDot('1', currentPage - 3),
            getFullPaginationDot('2', false, currentPage - 2),
            getFullPaginationDot('3', true, currentPage - 1),
            getFullPaginationDot('4', false, currentPage),
            getMediumPaginationDot('5', currentPage + 1),
        ],
    };
};
//# sourceMappingURL=pagination-dots.util.js.map